import PropTypes from 'prop-types';
import React from 'react';
import { Form, Grid, Row, Col } from 'react-bootstrap/lib';
import { widgetsScriptURL } from '../../../../util/constants';
import CodeTextArea from '../inputs/CodeTextArea';

function APIEditor(props) {
  const { website } = props;

  return (
    <Form>
      <Grid fluid>
        <Row>
          <Col sm={12}>
            <h4>Markup</h4>
            <small>
              Copy the markup below into your page template. Only add this
              script once per page.
            </small>
            <CodeTextArea
              label="Agent Script"
              value={`<!— Copy this markup into your page template after the closing <body/> tag —>\n<script src="${widgetsScriptURL}" type="text/javascript" id="prodigyButtonGroupAgent" websiteId="${website?.id}"></script>`}
            />

            <h4>
              Copy this following attributes onto any element in order to launch
              Upstart Online
            </h4>

            <CodeTextArea
              label="Browse"
              value={`onClick="Prodigy.openFrame('browse')" data-config-type="API"`}
            />

            <CodeTextArea
              label="Trade-In"
              value={`onClick="Prodigy.openFrame('trade-in')" data-config-type="API"`}
            />

            <CodeTextArea
              label="Credit Application"
              value={`onClick="Prodigy.openFrame('pre-approval')" data-config-type="API"`}
            />
          </Col>
        </Row>
      </Grid>
    </Form>
  );
}

APIEditor.propTypes = {
  website: PropTypes.object,
};

export default APIEditor;
